import { graphql } from '@/gql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const deleteCaller = async (phoneNumber: string): Promise<boolean> => {
  const response = await mutationExecute({
    mutation: graphql(`
      mutation DeleteCaller($phoneNumber: String!) {
        deleteCaller(phoneNumber: $phoneNumber)
      }
    `),
    variables: {
      phoneNumber,
    },
  });

  return !!response.data?.deleteCaller;
};
